import { Trans } from 'react-i18next';
import { Link, Text, type TextProps } from '@/ui';

export const MicrosoftApiDisclaimer = (props: TextProps) => (
  <Text color="customgray.mid" fontSize="sm" {...props}>
    <Trans i18nKey="calendars.microsoft_apis_terms" ns="settingsModal">
      Agenda Hero&apos;s use of information received from Microsoft APIs adheres
      to the{' '}
      <Link
        colorScheme="dark"
        href="https://learn.microsoft.com/legal/microsoft-apis/terms-of-use"
        rel="noreferrer"
        target="_blank"
      >
        Microsoft APIs Terms of Use
      </Link>
      .
    </Trans>
  </Text>
);
